const journey_properties = {
  appID: "104596_authe_app",
  realm: "ccb",
  sealId: "109208",
  cookieDomain: "domain=jpmchase.net",
  cookiePath: "path=/",
};

export default journey_properties;
